<template>
  <div class="search--banner">
    <!--    <section-loading class="search&#45;&#45;banner-loader" :show="loading" />-->
    <div class="d-flex justify-center">
      <img v-if="banner" :src="banner.image" alt="Search Banner" @click="openLink" />
      <!--    <div v-else class="filler"></div>-->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
const SectionLoading = () => import('@/components/content-loading/section-loading');

export default {
  components: {
    SectionLoading,
  },
  props: {
    type: {
      type: String,
      default: 'DESKTOP',
    },
  },
  data: () => ({}),
  computed: {
    ...mapState({
      loading: (state) => state.v2.search.banner.loading,
      banner: (state) => state.v2.search.banner.banner,
    }),
  },
  mounted() {
    const screenWidth = window.innerWidth;
    if (screenWidth <= 768 && this.type === 'MOBILE') {
      this.$store.dispatch('v2/search/banner/getBanner', 'MOBILE');
    } else if (screenWidth > 768 && this.type === 'DESKTOP') {
      this.$store.dispatch('v2/search/banner/getBanner', 'DESKTOP');
    }
  },
  methods: {
    openLink() {
      this.$router.push(`/banner/detail/${this.banner.uuid}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/utils/variables';
.search--banner {
  position: relative;
  width: 100%;
  margin-bottom: 16px;

  .search--banner-loader {
    width: 100%;
    min-height: 400px;

    @media #{$phones} {
      min-height: 150px;
    }
  }
  img {
    cursor: pointer;
    width: 100%;
    max-width: 340px;
    object-fit: contain;
    border-radius: 16px;

    @media #{$phones} {
      max-width: initial;
    }
  }
  .filler {
    min-height: 400px;

    @media #{$phones} {
      min-height: 150px;
    }
  }
}
</style>
